import Vue from 'vue'
import router from '../router'
import Component from '../components/NarrateAudio.vue'

const NarrateAudioConstructor = Vue.extend(Component)

const defaultProps = {
  btnVisialbe: false,
  filename: '',
  btnText: '继续',
  auto: false,
  hideBtn: false,
  onended () {},
}

let instance = null

function initInstance () {
  instance = new NarrateAudioConstructor({
    el: document.createElement('div'),
    router,
  })
  document.querySelector('#app').appendChild(instance.$el)
  return this
}

function _play (filename, options, callback) {
  if (!instance) {
    initInstance()
  }
  for (const prop in defaultProps) {
    instance[prop] = defaultProps[prop]
  }
  for (const prop in options) {
    if (defaultProps[prop] !== undefined) {
      instance[prop] = options[prop]
    }
  }
  if (filename) {
    instance.filename = filename
  } else {
    console.error('缺少filename参数！')
  }
  instance.callback = callback
  instance.play()
}

function playNarrate (filename, options = {}) {
  if (Vue.prototype.$isServer) {
    return
  }

  if (typeof Promise !== 'undefined') {
    return new Promise(resolve => {
      _play(filename, options, resolve)
    })
  }
}

export default {
  getInstance: () => instance,
  play: playNarrate,
  pause () {
    if (instance) {
      instance.pause()
    }
  },
  clear () {
    if (instance) {
      instance.clear()
    }
  },
  next () {
    if (instance) {
      instance.next()
    }
  },
  skip () {
    if (instance) {
      instance.skip()
    }
  },
}
